import Immutable from 'immutable';

/* global _CUSTOM_DOMAINS */

export const CUSTOM_DOMAIN_INSTITUTIONS = Immutable.fromJS(_CUSTOM_DOMAINS);
